import { useQuery } from 'react-query';
import { useToastError } from 'lib/hooks/useToastError';
import { EXPRESS_API } from 'configs/api/expressApi';
import { organizationVideoQueryKeys } from './queryKeys';

export interface OrganizationVideoFilter {
  key: string;
  type: string;
  label: string;
  name: string;
  options: { value: string; label: string; group?: string }[];
}

const getOrgVideoFilters = async (): Promise<{
  filters: OrganizationVideoFilter[];
}> => {
  return (await EXPRESS_API.get(`/organization-videos/filters`)).data;
};

export const useOrganizationVideoFiltersQuery = () => {
  const { showError } = useToastError();

  return useQuery(
    organizationVideoQueryKeys.filters(),
    () => getOrgVideoFilters(),
    {
      onError: showError,
      refetchOnMount: true,
    }
  );
};
